import React, { Fragment, useEffect } from 'react';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import config from '../../config';
import css from './invoice.module.css';
import { types as sdkTypes } from '../../util/sdkLoader';
import { formatMoney, unitDivisor } from '../../util/currency';
import moment from 'moment';
import Logo from '../Logo/Logo';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as Location } from '../../assets/locationPinNew.svg';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import {
  djobMail,
  djobSite,
  gstNumber,
  languageSelectOptions,
  qstNumber,
} from '../../marketplace-custom-config';
import classNames from 'classnames';
const { Money } = sdkTypes;

const formatHour = (hour, userNativeLang, showHourSuffix = true) => {
  const hoursStr = userNativeLang === languageSelectOptions.fr.value ? 'Heures' : 'Hours';
  const hourStr = userNativeLang === languageSelectOptions.fr.value ? 'Heure' : 'Hour';
  const suffix = hour > 1 ? hoursStr : hourStr;
  const hourInt = parseInt(hour);
  const min = Math.round((hour - hourInt) * 60);
  const prefix = hour;
  // const prefix = `${hourInt > 9 ? '' : '0'}${hourInt}:${min > 9 ? '' : '0'}${min}`;
  return prefix + ` ${showHourSuffix ? suffix : ''}`;
};

const WorkerInfo = ({ worker, userNativeLang, listing, intl }) => {
  const { attendance, workerName, workerId, hourlyRate, finalPayment } = worker;
  const {
    attributes: {
      publicData: { gigId },
    },
  } = listing;
  const [firstAtt] = attendance;
  if (!firstAtt) return null;
  const { attendanceEndDate, attendanceStartDate } = firstAtt;
  const totalWorkingHour = attendance.reduce(
    (acc, att) => moment(att.attendanceEndDate).diff(att.attendanceStartDate, 'minute') + acc,
    0
  );
  const djobWorkingHour = formatHour(totalWorkingHour / 60, userNativeLang, true);
  const userOffset = moment().utcOffset();
  const startTime = moment(attendanceStartDate)
    .subtract(userOffset, 'm')
    .format('HH:mm');
  const endTime = moment(attendanceEndDate)
    .subtract(userOffset, 'm')
    .format('HH:mm');

  const finalPaymentMoney = new Money(finalPayment * unitDivisor(config.currency), config.currency);
  return (
    <div className={css.workerDetails}>
      <div className={css.top}>
        <div className={css.left}>
          <div>
            <FormattedMessage id="Invoice.billBy" />
          </div>
          <div className={css.workerDetailsData}>
            <p>
              <FormattedMessage id="Invoice.djobberName" />
              <span>{workerName}</span>
            </p>
            <p>
              <FormattedMessage id="Invoice.djobberId" />
              <span>{workerId}</span>
            </p>
          </div>
        </div>
        <div className={css.right}>
          <div>
            <FormattedMessage id="Invoice.djobInfo" />
          </div>
          <div className={css.workerDetailsData}>
            <p>
              <FormattedMessage id="Invoice.djobWorkingHour" />
              <span>{djobWorkingHour}</span>
            </p>
            <p>
              <FormattedMessage id="Invoice.startTime" /> <span>{startTime}</span> &nbsp;&nbsp;
              <FormattedMessage id="Invoice.endTime" /> <span>{endTime}</span>
            </p>
          </div>
        </div>
      </div>
      <div className={css.bottom}>
        <div className={classNames(css.row, css.tableHeadingRow)}>
          <span>{intl.formatMessage({ id: 'Invoice.workerInvoiceNumber' })}</span>
          <span>{intl.formatMessage({ id: 'Invoice.date' })}</span>
          <span>{intl.formatMessage({ id: 'Invoice.totalWorkingHour' })}</span>
          <span>{intl.formatMessage({ id: 'Invoice.PriceHour' })}</span>
          <span>{intl.formatMessage({ id: 'Invoice.Charged' })}</span>
        </div>
        {attendance.map((att, indx) => {
          const { paymentDate, lastConfirmedWorkingHour, totalPaymentForShow } = att;
          const paymentDatestr = moment(paymentDate)
            .subtract(userOffset)
            .format('YYYY-MM-DD');

          const totalPaymentMoney = new Money(
            totalPaymentForShow * unitDivisor(config.currency),
            config.currency
          );
          return (
            <div key={indx} className={classNames(css.row, css.tableDataRow)}>
              <span className={css.invoiceNum}>
                {gigId}/{workerId}
              </span>
              <span>{paymentDatestr}</span>
              <span>{lastConfirmedWorkingHour}</span>
              <span>{hourlyRate}</span>
              <span>{totalPaymentMoney?.amount ? formatMoney(intl, totalPaymentMoney) : null}</span>
            </div>
          );
        })}
        <div className={classNames(css.row, css.tableDataRow)}>
          <span />
          <span />
          <span>{intl.formatMessage({ id: 'BusinessCheckoutPage.gstTaxes' })}</span>
          <span />
          <span>-</span>
        </div>
        <div className={classNames(css.row, css.tableDataRow)}>
          <span />
          <span />
          <span>{intl.formatMessage({ id: 'BusinessCheckoutPage.qstTaxes' })}</span>
          <span />
          <span>-</span>
        </div>
        <div className={classNames(css.row, css.tableDataRow)}>
          <span />
          <span />
          <span>{intl.formatMessage({ id: 'Invoice.TotalAmount' })}</span>
          <span />
          <span>{formatMoney(intl, finalPaymentMoney)}</span>
        </div>
      </div>
    </div>
  );
};

function Invoice(props) {
  const {
    currentListing,
    userNativeLang,
    user,
    jobCategoryOptions,
    jobSubCategoryOptions,
    reducedJobSubCategory,
    intl,
    invoiceData,
    // FormattedMessage,
  } = props;

  const publishedDate = currentListing?.attributes?.publicData?.gigPublishedDate;
  const myDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const workerCount = currentListing && currentListing?.attributes?.publicData?.workerYouNeed;
  const workers = currentListing?.attributes?.publicData?.workers || [];
  const acceptedWorkers = currentListing?.attributes?.metadata?.acceptedWorkers || [];

  const listingPrice =
    currentListing &&
    new Money(
      currentListing?.attributes?.publicData?.clientPrice?.amount || 0,
      currentListing?.attributes?.publicData?.clientPrice?.currency
    );

  const isCancelledByBusiness = currentListing?.attributes?.metadata?.isCancelledByBusiness;
  const cancelDate = isCancelledByBusiness ? currentListing?.attributes?.metadata?.closeDate : null;
  const sep = userNativeLang === languageSelectOptions.fr.value ? 'à' : 'at';
  const cancelDateStr = cancelDate
    ? `${moment(cancelDate).format('DD MMM YYYY')} ${sep} ${moment(cancelDate).format('HH[h]mm')}`
    : '';
  const priceData = (price, intl) => {
    if (price && price.currency === config.currency) {
      const formattedClientPrice = formatMoney(intl, price);

      return { formattedClientPrice, priceTitle: formattedClientPrice };
    } else if (price) {
      return {
        formattedClientPrice: intl.formatMessage(
          { id: 'ManageListingCard.unsupportedPrice' },
          { currency: price.currency }
        ),
        priceTitle: intl.formatMessage(
          { id: 'ManageListingCard.unsupportedPriceTitle' },
          { currency: price.currency }
        ),
      };
    }
    return {};
  };
  const { formattedClientPrice, priceTitle } = priceData(
    listingPrice || new Money(0, config.currency),
    intl
  );
  const oneTimeScheduleList =
    (currentListing && currentListing?.attributes?.publicData?.oneTimeScheduleList) ?? [];
  const recurringScheduleList =
    (currentListing && currentListing?.attributes?.publicData?.recurringScheduleList) ?? [];

  const { scheduleType } = (currentListing && currentListing?.attributes?.publicData) || '';

  // total duration in minute calculation

  const totalWorkingHourInMin = o => {
    // Start time
    const startTimeHour = parseInt(o?.startTime?.hours?.value, 10);
    const startTimeMinute = parseInt(o?.startTime?.min?.value, 10);

    // End time
    const endTimeHour = parseInt(o?.endTime?.hours?.value);
    const endTimeMinute = parseInt(o?.endTime?.min?.value);

    const sDate = moment(o?.startDate?.date).set({
      hour: startTimeHour,
      minute: startTimeMinute,
    });

    // let eDate = moment(o?.endDate ? o?.endDate?.date : o?.startDate?.date).set({
    let eDate = moment(o?.startDate?.date).set({
      hour: endTimeHour,
      minute: endTimeMinute,
    });

    if (startTimeHour > endTimeHour) {
      eDate.add(1, 'day');
    }
    // Convert hours to minutes

    const startTimeInMinutes =
      startTimeHour !== 0 ? startTimeHour * 60 + startTimeMinute : startTimeMinute;
    const endTimeInMinutes = endTimeHour !== 0 ? endTimeHour * 60 + endTimeMinute : endTimeMinute;

    const unpaidBreak = parseInt(o?.unpaidBreak?.value);

    const durationInMinutes =
      unpaidBreak < 0 ? eDate.diff(sDate, 'minutes') : eDate.diff(sDate, 'minutes') - unpaidBreak;

    return durationInMinutes;
  };

  // working hour for one-time schedule calculation

  const oneTimeWorkInMin =
    scheduleType === 'oneTime' &&
    currentListing &&
    oneTimeScheduleList &&
    oneTimeScheduleList?.[0].startDate?.date !== null &&
    oneTimeScheduleList?.map(totalWorkingHourInMin);

  const totalOneTimeWorkDurationInMin =
    currentListing && oneTimeWorkInMin && oneTimeWorkInMin?.reduce((a, b) => a + b, 0);

  // working hour for recurring schedule calculation

  const countTotalDaysInDateRange = (startDate, endDate, weekdays) => {
    const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
    let currentDate = new Date(startDate);
    const targetDate = new Date(endDate);
    // Create an object to store the counts for each weekday
    const weekdayCounts = {};
    weekdays.forEach(weekday => {
      weekdayCounts[weekday] = 0;
    });

    // Iterate through the dates in the range
    while (currentDate <= targetDate) {
      const dayOfWeek = currentDate.getDay();
      const someday = myDays[dayOfWeek];

      // Check if the day is in the provided weekdays array
      if (weekdays.includes(someday)) {
        weekdayCounts[someday]++;
      }

      currentDate.setTime(currentDate.getTime() + oneDay); // Move to the next day
    }
    const totalDays = Object.values(weekdayCounts).reduce((a, b) => a + b, 0);

    return totalDays;
  };

  const recDaysArray = [];
  currentListing &&
    scheduleType === 'recurring' &&
    recurringScheduleList?.map(o => {
      const recurringIntervalType = o?.recurringInterval?.value;

      if (recurringIntervalType === 'Daily') {
        let date1 = moment(o?.startDate?.date);
        let date2 = moment(o?.endDate?.date);

        let totalDays = date2.diff(date1, 'days') + 1;
        recDaysArray.push(totalDays);
      } else {
        const totalDays = countTotalDaysInDateRange(
          moment(o?.startDate?.date).format('YYYY-MM-DD'),
          moment(o?.endDate?.date).format('YYYY-MM-DD'),
          o.recurringDays && typeof o.recurringDays === 'string' ? o.recurringDays.split(',') : []
        );

        recDaysArray.push(totalDays);
      }
    });

  const ListOfRecurringWorkInMin =
    scheduleType === 'recurring' &&
    currentListing &&
    recurringScheduleList &&
    recurringScheduleList?.[0].recurringInterval !== '' &&
    recurringScheduleList?.map(totalWorkingHourInMin);

  const recurringWorkDurationInMin =
    ListOfRecurringWorkInMin &&
    ListOfRecurringWorkInMin?.map((m, indx) => m * recDaysArray[indx]).reduce((a, b) => a + b, 0);

  const totalWorkingDurationInminForCommission =
    (scheduleType === 'oneTime' ? totalOneTimeWorkDurationInMin : recurringWorkDurationInMin) *
    workers.length;

  const totalWorkingDurationInmin =
    workers.reduce((acc, curnt) => curnt.finalWorkingHour + acc, 0) * 60;

  const djobTotalWorkingDurationInMin =
    workers.reduce((acc, curnt) => {
      const workerHour = curnt.attendance.reduce(
        (acc, att) => att.lastConfirmedWorkingHour + acc,
        0
      );
      return workerHour + acc;
    }, 0) * 60;

  const convertHourPriceToMinutePrice = priceInCentsPerHour => {
    const minutesPerHour = 60;
    const priceInCentsPerMinute = priceInCentsPerHour / minutesPerHour;
    return priceInCentsPerMinute;
  };

  // const getOvertimeAndRefundPriceArr = () => {
  //   const metadata = currentListing?.attributes?.metadata ?? {};
  //   const refundAndOvertimeLabelArr = [];
  //   let extraAmountPaid = 0;
  //   for (let key in metadata) {
  //     if (key.startsWith('overtime')) {
  //       const data = metadata[key];
  //       extraAmountPaid += data.amount;
  //       const money = formatMoney(intl, new Money(data.amount, data.currency));
  //       const label =
  //         userNativeLang === languageSelectOptions.en.value
  //           ? 'Overtime charged' +
  //             (data.workerId ? ` for worker ${data.workerId}` : '') +
  //             (data.workDate ? ` for work on ${data.workDate}` : '')
  //           : 'Heures supplémentaires facturées' +
  //             (data.workerId ? ` pour le travailleur ${data.workerId}` : '') +
  //             (data.workDate ? ` pour le travail du ${data.workDate}` : '');
  //       refundAndOvertimeLabelArr.push({ label: label, amount: money });
  //     }
  //     if (key.startsWith('refund')) {
  //       const data = metadata[key];
  //       extraAmountPaid -= data.amount;
  //       const money = formatMoney(intl, new Money(data.amount, data.currency));
  //       const label =
  //         userNativeLang === languageSelectOptions.en.value
  //           ? 'Amount Refunded' +
  //             (data.workerId ? ` for worker ${data.workerId}` : '') +
  //             (data.workDate ? ` for work on ${data.workDate}` : '')
  //           : 'Montant Remboursé' +
  //             (data.workerId ? ` pour le travailleur ${data.workerId}` : '') +
  //             (data.workDate ? ` pour le travail du ${data.workDate}` : '');
  //       refundAndOvertimeLabelArr.push({ label: label, amount: `-${money}` });
  //     }
  //   }
  //   return { refundAndOvertimeLabelArr, extraAmountPaid };
  // };

  // const { refundAndOvertimeLabelArr, extraAmountPaid } = getOvertimeAndRefundPriceArr();
  const clienPrice = listingPrice?.amount || 0;
  const priceInCentsPerHour = currentListing?.attributes?.price?.amount || 0;
  const priceInCentsPerMinute = convertHourPriceToMinutePrice(priceInCentsPerHour);
  const workerPricePerMinute = Math.max(
    0,
    convertHourPriceToMinutePrice(clienPrice) - priceInCentsPerMinute
  );

  const totalWages = new Money(totalWorkingDurationInmin * priceInCentsPerMinute, config.currency);
  const djobTotalWages = new Money(
    djobTotalWorkingDurationInMin * priceInCentsPerMinute,
    config.currency
  );

  const djobComission = new Money(
    djobTotalWorkingDurationInMin * workerPricePerMinute,
    config.currency
  );

  const clientPriceWithDjobComission = new Money(
    djobComission.amount + totalWages.amount,
    config.currency
  );

  const totalWagesAsMoney = priceData(totalWages, intl)?.formattedClientPrice;

  //sos commission
  // const totalcommission = new Money((totalWages.amount || 0) / 2, config.currency);

  // const totalCommissionAsMoney = priceData(totalcommission || 0, intl)?.formattedClientPrice;
  const djobComissionAsMoney = priceData(djobComission, intl)?.formattedClientPrice;
  const djobComissionPercentage = Math.round(
    parseFloat(
      ((clientPriceWithDjobComission.amount - totalWages.amount) / (totalWages.amount || 1)) * 100
    )
  ).toFixed(2);

  //wages without taxes

  // const wagesWithoutTaxes = new Money(
  //   (totalWages.amount || 0) + (totalcommission.amount || 0),
  //   config.currency
  // );

  const wagesWithoutTaxes = new Money(totalWages.amount || 0, config.currency);
  const djobWagesWithoutTaxes = new Money(djobTotalWages.amount || 0, config.currency);
  const wagesWithoutTaxesAsMoney = priceData(wagesWithoutTaxes || 0, intl)?.formattedClientPrice;

  //wages with gst
  const gstTax = new Money(
    Math.round(((djobComission.amount || 0) * config.gstPercent) / 100),
    config.currency
  );
  const gstTaxAsMoney = priceData(gstTax || 0, intl)?.formattedClientPrice;

  //wages with qst
  const qstTax = new Money(
    Math.round(((djobComission.amount || 0) * config.qstPercent) / 100),
    config.currency
  );
  const qstTaxAsMoney = priceData(qstTax || 0, intl)?.formattedClientPrice;

  const totalcommission = new Money(
    djobComission.amount + qstTax.amount + gstTax.amount,
    config.currency
  );
  const totalcommissionAsMoney = priceData(totalcommission || 0, intl)?.formattedClientPrice;

  //total amount
  const totalAmount = new Money(
    Math.abs(
      wagesWithoutTaxes.amount || 0
      // (extraAmountPaid || 0)
    ),
    config.currency
  );

  //total amount
  const djobTotalAmount = new Money(
    Math.abs(
      djobWagesWithoutTaxes.amount || 0
      // (extraAmountPaid || 0)
    ),
    config.currency
  );

  const totalAmountAsMoney = priceData(totalAmount || 0, intl)?.formattedClientPrice;
  const djobTotalAmountAsMoney = priceData(djobTotalAmount || 0, intl)?.formattedClientPrice;

  //listing times
  const oneTimeStartTimeHour =
    scheduleType === 'oneTime' &&
    currentListing?.attributes?.publicData?.oneTimeScheduleList &&
    parseInt(
      currentListing?.attributes?.publicData?.oneTimeScheduleList?.map(
        (m, indx) => m?.startTime?.hours?.value
      )
    );
  const oneTimeStartTimeMin =
    scheduleType === 'oneTime' &&
    currentListing?.attributes?.publicData?.oneTimeScheduleList &&
    parseInt(
      currentListing?.attributes?.publicData?.oneTimeScheduleList.map(
        (m, indx) => m?.startTime?.min?.value
      )
    );
  const oneTimeEndTimeHour =
    scheduleType === 'oneTime' &&
    currentListing?.attributes?.publicData?.oneTimeScheduleList &&
    parseInt(
      currentListing?.attributes?.publicData?.oneTimeScheduleList.map(
        (m, indx) => m?.endTime?.hours?.value
      )
    );
  const oneTimeEndTimeMin =
    scheduleType === 'oneTime' &&
    currentListing?.attributes?.publicData.oneTimeScheduleList &&
    parseInt(
      currentListing?.attributes?.publicData?.oneTimeScheduleList.map(
        (m, indx) => m?.endTime?.min?.value
      )
    );
  const oneTimeUnpaidBreak =
    scheduleType === 'oneTime' &&
    currentListing?.attributes?.publicData?.oneTimeScheduleList &&
    parseInt(
      currentListing?.attributes?.publicData?.oneTimeScheduleList?.map(
        (m, indx) => m?.unpaidBreak?.value
      )
    );

  const recStartTimeHour =
    scheduleType === 'recurring' &&
    currentListing?.attributes?.publicData?.recurringScheduleList &&
    parseInt(
      currentListing?.attributes?.publicData?.recurringScheduleList?.map(
        (m, indx) => m?.startTime?.hours?.value
      )
    );
  const recStartTimeMin =
    scheduleType === 'recurring' &&
    currentListing?.attributes?.publicData?.recurringScheduleList &&
    parseInt(
      currentListing?.attributes?.publicData?.recurringScheduleList?.map(
        (m, indx) => m?.startTime?.min?.value
      )
    );
  const recEndTimeHour =
    scheduleType === 'recurring' &&
    currentListing?.attributes?.publicData?.recurringScheduleList &&
    parseInt(
      currentListing?.attributes?.publicData?.recurringScheduleList?.map(
        (m, indx) => m?.endTime?.hours?.value
      )
    );
  const recEndTimeMin =
    scheduleType === 'recurring' &&
    currentListing?.attributes?.publicData?.recurringScheduleList &&
    parseInt(
      currentListing?.attributes?.publicData?.recurringScheduleList?.map(
        (m, indx) => m?.endTime?.min?.value
      )
    );
  const recUnpaidBreak =
    scheduleType === 'recurring' &&
    currentListing?.attributes?.publicData?.recurringScheduleList &&
    parseInt(
      currentListing?.attributes?.publicData?.recurringScheduleList?.map(
        (m, indx) => m?.unpaidBreak?.value
      )
    );

  const startTimeInMin = oneTimeStartTimeHour * 60 + oneTimeStartTimeMin;
  const endTimeInMin = oneTimeEndTimeHour * 60 + oneTimeEndTimeMin;

  const recstartTimeInMin = recStartTimeHour * 60 + recStartTimeMin;
  const recendTimeInMin = recEndTimeHour * 60 + recEndTimeMin;

  let oneTimeWorkDurationInMIn = endTimeInMin - startTimeInMin - oneTimeUnpaidBreak;
  let recWorkDurationInMIn = recendTimeInMin - recstartTimeInMin - recUnpaidBreak;

  if (oneTimeWorkDurationInMIn < 0) {
    oneTimeWorkDurationInMIn += 24 * 60;
  }
  if (recWorkDurationInMIn < 0) {
    recWorkDurationInMIn += 24 * 60;
  }
  const durationHours = Math.floor(oneTimeWorkDurationInMIn / 60);
  const durationMinutes = oneTimeWorkDurationInMIn % 60;
  const recdurationHours = Math.floor(recWorkDurationInMIn / 60);
  const recdurationMinutes = recWorkDurationInMIn % 60;

  return (
    <div className={css.invoiceContainer}>
      <div className={css.invoiceTop}>
        <div className={css.invoiceTopLeft}>
          <div className={css.invoiceInfo}>
            {' '}
            <FormattedMessage id="Invoice.BillToPay" className={css.Text} />
          </div>
        </div>
        <div className={css.invoiceMiddle}>
          <div className={classNames(css.businessName, css.invoiceInfo)}>
            {' '}
            <span>{user?.attributes?.profile?.publicData?.companyName}</span>
          </div>
          <div className={css.Text}>
            {user?.attributes?.profile?.publicData?.companyAddress?.address}
          </div>
          <div className={css.Text}> {user?.attributes?.profile?.publicData?.customId}</div>
        </div>
        <div className={css.invoiceTopRight}>
          {/* <div className={css.invoiceInfoWrapper}> */}
          <div className={css.invoiceInfo}>
            {' '}
            <FormattedMessage id="Invoice.Invoice" className={css.Text} />{' '}
          </div>
          {/* <div className={css.informationContainer}> */}
          <div className={css.DataDiv}>
            <FormattedMessage id="Invoice.invoiceDate" className={css.Text} />
            <span>{moment(invoiceData?.[0]?.updatedAt).format('DD/MM/YY')}</span>
          </div>
          <div className={css.DataDiv}>
            <FormattedMessage id="Invoice.paymentTerms" className={css.Text} />
            <span>
              <FormattedMessage id="Invoice.paymentType" />
            </span>
          </div>
          {/* <div className={css.DataDiv}>
                <div>
                  {' '}
                  <FormattedMessage id="Invoice.customerNo" className={css.Text} />
                </div>
              </div> */}
          {/* <div className={css.DataDiv}>
                <div>
                  {' '}
                  <FormattedMessage id="Invoice.currency" className={css.Text} />
                </div>
                <div className={css.No}>CAD</div>
              </div> */}
        </div>
        {/* </div> */}
        {/* </div> */}
      </div>

      {/* <div className={css.InvoHeading}> */}
      {/* <div className={css.invoHeadingLeftDiv}> */}

      {/* <div className={css.rightDiv}>
          <div className={css.SosAndTax}>
            <div className={css.CompanyName}>
              <FormattedMessage id="ListingPage.featuresTitle" />
            </div>
            <div>
              <div className={css.taxText}>
                <FormattedMessage id="Invoice.TaxInvoice" />
              </div>
            </div>
          </div>
          <div className={css.gstandOriginal}>
            <div>
              <span className={css.Text}>
                <FormattedMessage id="Invoice.GSTNo" />
              </span>{' '}
              <span className={css.No}>{gstNumber}</span>
            </div>
            {invoiceData?.[0]?.paymentIntentStatus === 'requires_payment_method' ? (
              <div>
                <FormattedMessage id="Invoice.draftCopy" />
              </div>
            ) : (
              <div>
                <FormattedMessage id="Invoice.originalCopy" />
              </div>
            )}
          </div>

          <div>
            <span className={css.Text}>
              <FormattedMessage id="Invoice.QSTNo" />
            </span>{' '}
            <span className={css.No}>{qstNumber}</span>
          </div>
        </div> */}
      {/* </div> */}
      {/* </div> */}
      <div className={css.padding}>
        <div className={css.invoiceWrapper}>
          <div className={css.invoice}>
            {' '}
            <span>{intl.formatMessage({ id: 'Invoice.djobInfo' })}&nbsp;:</span>
          </div>

          {/* {!!publishedDate && publishedDate !== undefined ? (
            <div className={css.publicationDiv}>
              <FormattedMessage id="SearchPage.Dateofpublication" />
              <span className={css.No}>{moment(publishedDate).format('DD/MM/YY')} </span>
            </div>
          ) : null} */}
          <div className={css.extraDiv}>
            <div className={css.TextDiv}>
              <span>{intl.formatMessage({ id: 'Invoice.gigTitle' })}</span>
              <span>{currentListing?.attributes?.title}</span>
            </div>
            {currentListing?.attributes?.publicData?.listingAddress?.address ||
            currentListing?.attributes?.publicData?.listingAddress?.postalCode ? (
              <div className={css.locationDiv}>
                <span>{intl.formatMessage({ id: 'Invoice.gigAddress' })}</span>
                <span>
                  {currentListing?.attributes?.publicData?.listingAddress?.address},
                  {currentListing?.attributes?.publicData?.listingAddress.postalCode}
                </span>
              </div>
            ) : null}
          </div>
          {/* <div className={css.categoryWrapper}>
            <span className={css.Text}>
              {jobCategoryOptions
                ?.filter(f =>
                  currentListing?.attributes?.publicData?.jobCategories.find(
                    m => m.category === f.value
                  )
                )
                ?.map(m => m.label[userNativeLang])}
            </span>

            <span className={css.Text}>
              {` - `}
              {
                reducedJobSubCategory.find(
                  m =>
                    currentListing?.attributes?.publicData?.jobCategories[0]?.subCategory ===
                    m.value
                )?.label[userNativeLang]
              }
            </span>
          </div> */}

          <div className={css.extraDiv}>
            {currentListing?.attributes?.publicData?.workerYouNeed ? (
              <div className={css.TotalWorkerDiv}>
                <FormattedMessage id="SearchPage.totalProposedWorker" className={css.Text} />{' '}
                <span>{currentListing?.attributes?.publicData?.workerYouNeed}</span>
              </div>
            ) : null}
            {/* <div className={css.Details}> */}
            {/* {formattedClientPrice ? (
            <span className={css.gigPrice}>
              <FormattedMessage id="SearchPage.Priceperhour" className={css.Text} /> &nbsp;
              <span className={css.No}>{formattedClientPrice}</span>
            </span>
          ) : null} */}

            <div className={css.hourDiv}>
              {scheduleType === 'oneTime' &&
                currentListing?.attributes?.publicData.oneTimeScheduleList &&
                currentListing?.attributes?.publicData?.oneTimeScheduleList.map((m, indx) => {
                  return (
                    <Fragment key={indx}>
                      {indx > 0 ? (
                        <>
                          {/* <hr className={css.hrColor} /> */}
                          {/* <div className={css.workPerDay}> */}
                          {/* {durationHours ? <FormattedMessage id="SearchPage.workPerDay" /> : null}
                          &nbsp;
                          <b>
                            {durationHours ? (
                              <>
                                {durationHours}
                                {` `}
                                <FormattedMessage id="ListingCardCustom.hours" />
                              </>
                            ) : null}
                            {durationMinutes !== 0 && typeof durationMinutes !== NaN
                              ? ` ${durationMinutes} minutes`
                              : null}
                          </b>{' '}
                          {m?.unpaidBreak?.value && parseInt(m?.unpaidBreak?.value) > 0 ? (
                            <>
                              -&nbsp;
                              <FormattedMessage id="SearchPage.unpaidBreak" />
                              &nbsp;
                              <b>{m?.unpaidBreak?.value} Minutes</b>
                            </>
                          ) : null} */}
                          {m?.startDate?.date ? (
                            <>
                              {/* {Object.values(m?.startDate?.date).length === 0 ? null : ` - `} */}
                              <FormattedMessage id="Invoice.djobDate" />{' '}
                              <span> {moment(m?.startDate?.date).format('Do MMM, y')}</span>
                            </>
                          ) : null}
                          {/* </div> */}
                          {/* <div className={css.scheduleDiv}>
                          <div className={css.workerCountDiv}>
                            {' '}
                            <span>
                              <FormattedMessage id="FieldDateTimeInput.startTime" /> :
                            </span>
                            <span>
                              {m?.startTime?.hours.value} : {m?.startTime?.min.value} &nbsp;- &nbsp;
                            </span>{' '}
                          </div>
                          <div className={css.workerCountDiv}>
                            {' '}
                            <span>
                              <FormattedMessage id="FieldDateTimeInput.endTime" /> :
                            </span>
                            <span>
                              {m?.endTime?.hours.value} : {m?.endTime?.min.value}
                            </span>{' '}
                          </div>
                        </div> */}
                        </>
                      ) : (
                        <React.Fragment>
                          {/* <div className={css.workPerDay}> */}
                          {/* {durationHours ? <FormattedMessage id="SearchPage.workPerDay" /> : null}
                        &nbsp;
                        <b>
                          {durationHours ? (
                            <>
                              {durationHours}
                              {` `}
                              <FormattedMessage id="ListingCardCustom.hours" />
                            </>
                          ) : null}
                          {durationMinutes !== 0 && typeof durationMinutes !== NaN
                            ? ` ${durationMinutes} minutes`
                            : null}
                        </b> */}
                          {/* {m?.unpaidBreak?.value && parseInt(m?.unpaidBreak?.value) > 0 ? (
                          <>
                            &nbsp;-&nbsp;
                            <FormattedMessage id="SearchPage.unpaidBreak" />
                            &nbsp;
                            <b>{m?.unpaidBreak?.value} Minutes</b>
                          </>
                        ) : null} */}
                          {m?.startDate?.date ? (
                            <>
                              {/* {Object.values(m?.startDate?.date).length === 0 ? null : ` - `} */}
                              <FormattedMessage id="Invoice.djobDate" />{' '}
                              <span> {moment(m?.startDate?.date).format('Do MMM, y')}</span>
                            </>
                          ) : null}
                          {/* </div> */}
                        </React.Fragment>
                      )}
                      {/* <div className={css.scheduleDiv}>
                      <div className={css.workerCountDiv}>
                        {' '}
                        <span>
                          <FormattedMessage id="FieldDateTimeInput.startTime" /> :
                        </span>
                        <span>
                          {m?.startTime?.hours.value} : {m?.startTime?.min.value} &nbsp;- &nbsp;
                        </span>{' '}
                        <span>
                          <FormattedMessage id="FieldDateTimeInput.endTime" /> :
                        </span>
                        <span>
                          {m?.endTime?.hours.value} : {m?.endTime?.min.value}
                        </span>{' '}
                      </div>
                     
                    </div> */}
                    </Fragment>
                  );
                })}
              {scheduleType === 'recurring' &&
                currentListing?.attributes?.publicData?.recurringScheduleList &&
                currentListing?.attributes?.publicData?.recurringScheduleList?.map((r, indx) => {
                  const recurringDays =
                    typeof r?.recurringDays === 'string'
                      ? r?.recurringDays?.split(',')
                      : r?.recurringDays?.map(m => m);
                  return (
                    <Fragment key={indx}>
                      {r?.startDate?.date !== null ? (
                        <>
                          {indx > 0 &&
                          currentListing?.attributes?.publicData?.recurringScheduleList[0]?.date
                            ?.date !== null ? (
                            <>
                              {/* <hr className={css.hrColor} /> */}
                              {/* <div className={css.recWorkperDay}>
                              {recdurationHours ? (
                                <FormattedMessage id="SearchPage.workPerDay" />
                              ) : null}
                              &nbsp;
                              <b>
                                {' '}
                                {recdurationHours ? (
                                  <>
                                    {recdurationHours}
                                    {` `}
                                    <FormattedMessage id="ListingCardCustom.hours" />
                                  </>
                                ) : null}
                                {recdurationMinutes !== 0 && typeof recdurationMinutes !== NaN
                                  ? ` ${recdurationMinutes} minutes`
                                  : null}
                              </b>{' '}
                              {r?.unpaidBreak?.value && parseInt(r?.unpaidBreak?.value) > 0 ? (
                                <>
                                  -&nbsp;
                                  <FormattedMessage id="SearchPage.unpaidBreak" />
                                  &nbsp;
                                  <b>{r?.unpaidBreak?.value} Minutes</b>
                                </>
                              ) : null}
                            </div> */}
                              {/* <div className={css.workPerDay}> */}
                              {/* <FormattedMessage id="SearchPage.recurringDays" />
                              &nbsp;
                              {recurringDays[0] === '' ? (
                                <>
                                  <b>
                                    <FormattedMessage id="SearchPage.Daily" />
                                  </b>
                                </>
                              ) : (
                                recurringDays.map((m, indx) =>
                                  indx > 0 ? (
                                    <>
                                      <b>, {m}</b>
                                    </>
                                  ) : (
                                    <b>{m}</b>
                                  )
                                )
                              )}
                              &nbsp;-  */}
                              <FormattedMessage id="Invoice.djobDate" />{' '}
                              <span> {moment(r?.startDate?.date).format('Do MMM, y')}</span>
                              {' - '}
                              {/* <FormattedMessage id="SearchPage.to" />{' '} */}
                              <span> {moment(r?.endDate?.date).format('Do MMM, y')}</span>
                              {/* </div> */}
                            </>
                          ) : (
                            <>
                              {/* <div className={css.recWorkperDay}>
                              {recdurationHours ? (
                                <FormattedMessage id="SearchPage.workPerDay" />
                              ) : null}
                              &nbsp;
                              <b>
                                {' '}
                                {recdurationHours ? (
                                  <>
                                    {recdurationHours}
                                    {` `}
                                    <FormattedMessage id="ListingCardCustom.hours" />
                                  </>
                                ) : null}
                                {recdurationMinutes !== 0 && typeof recdurationMinutes !== NaN
                                  ? ` ${recdurationMinutes} minutes`
                                  : null}
                              </b>{' '}
                              {r?.unpaidBreak?.value && parseInt(r?.unpaidBreak?.value) > 0 ? (
                                <>
                                  -&nbsp;
                                  <FormattedMessage id="SearchPage.unpaidBreak" />
                                  &nbsp;
                                  <b>{r?.unpaidBreak?.value} Minutes</b>
                                </>
                              ) : null}
                            </div> */}
                              {/* <div className={css.workPerDay}> */}
                              {/* <FormattedMessage id="SearchPage.recurringDays" />
                              &nbsp;
                              {recurringDays[0] === '' ? (
                                <>
                                  <b>
                                    <FormattedMessage id="SearchPage.Daily" />
                                  </b>
                                </>
                              ) : (
                                recurringDays.map((m, indx) =>
                                  indx > 0 ? (
                                    <>
                                      <b>, {m}</b>
                                    </>
                                  ) : (
                                    <b>{m}</b>
                                  )
                                )
                              )} */}
                              {/* &nbsp;- */}
                              <FormattedMessage id="Invoice.djobDate" />{' '}
                              <span> {moment(r?.startDate?.date).format('Do MMM, y')}</span>
                              {' - '}
                              {/* <FormattedMessage id="SearchPage.to" />{' '} */}
                              <span> {moment(r?.endDate?.date).format('Do MMM, y')}</span>
                              {/* </div> */}
                              {/* <div className={css.scheduleDiv}>
                              <div className={css.workerCountDiv}>
                                {' '}
                                <span>
                                  <FormattedMessage id="FieldDateTimeInput.startTime" /> :
                                </span>
                                <span>
                                  {r?.startTime?.hours.value} : {r?.startTime?.min.value} &nbsp;-
                                  &nbsp;
                                </span>{' '}
                                <span>
                                  <FormattedMessage id="FieldDateTimeInput.endTime" /> :
                                </span>
                                <span>
                                  {r?.endTime?.hours.value} : {r?.endTime?.min.value}
                                </span>{' '}
                              </div>
                             
                            </div> */}
                            </>
                          )}
                        </>
                      ) : null}
                    </Fragment>
                  );
                })}
            </div>
          </div>
          {/* </div> */}
        </div>
        {isCancelledByBusiness ? (
          <p className={css.gigCancelError}>
            <FormattedMessage id="Invoice.listingClose" values={{ date: cancelDateStr }} />
          </p>
        ) : null}
        {/* <div className={css.hr}></div> */}
        <div className={css.PriceBreakDownContainer}>
          <p className={css.invoiceHeading}>
            <FormattedMessage id="Invoice.employeFeeInfo" />
          </p>
          {/* <div className={css.DataDiv}>
            <div className={css.Text}>
              {' '}
              <FormattedMessage id="Invoice.NetAmount" />
            </div>
            <div className={css.No}>{wagesWithoutTaxesAsMoney}</div>
          </div> */}
          {workers.map((worker, indx) => {
            const workingHour = formatHour(worker.finalWorkingHour, userNativeLang, true);
            const amount = formatMoney(
              intl,
              new Money(worker.finalPayment * unitDivisor(config.currency), config.currency)
            );
            return (
              <WorkerInfo
                worker={worker}
                userNativeLang={userNativeLang}
                listing={currentListing}
                intl={intl}
                key={indx}
              />
              // {/*<div className={css.DataDiv}> <div className={css.Text}>
              //   {' '}
              //   <FormattedMessage
              //     id="Invoice.workerPaid"
              //     values={{
              //       workerName: worker.workerName,
              //       workerId: worker.workerId,
              //       workingHour,
              //     }}
              //   />
              // </div>
              // <div className={css.No}>{amount}</div> </div>*/}
            );
          })}
          <div>
            <p className={css.invoiceHeading}>
              <FormattedMessage id="Invoice.platformFeeInfo" />
            </p>
            <div className={css.djobInfoContent}>
              <Logo
                format="desktop"
                className={css.logo}
                alt={intl.formatMessage({
                  id: 'TopbarDesktop.logo',
                })}
              />
              <div className={css.djobInfo}>
                <span className={css.email}>
                  <FormattedMessage id="Invoice.platformEmailInfo" />
                  <span>{djobMail}</span>
                </span>
                <span className={css.site}>
                  <FormattedMessage id="Invoice.platformSiteInfo" />
                  <span>{djobSite}</span>
                </span>
              </div>
            </div>
          </div>
          {/* <div className={css.DataDiv}>
            <span className={css.Text}>
              <FormattedMessage id="Invoice.djobCommission" />
            </span>
            <span className={css.No}>{djobComissionAsMoney}</span>
          </div> */}
          {/* <div className={css.hr}></div> */}
          <div>
            <div className={css.finalBreakDown}>
              <div className={css.tableHeadingRow}>
                <span>{intl.formatMessage({ id: 'Invoice.invoiceNumber' })}</span>
                <span>{intl.formatMessage({ id: 'Invoice.totalWorkerFeeInfo' })}</span>
                <span>{intl.formatMessage({ id: 'Invoice.djobFeeInfo' })}</span>
                <span>{intl.formatMessage({ id: 'Invoice.totalCharged' })}</span>
                {/* <FormattedMessage id="" className={css.Text} /> */}
              </div>
              <div className={css.tableDataRow}>
                <span> {currentListing?.attributes?.publicData?.gigId}</span>
                <span>{djobTotalAmountAsMoney}</span>
                <span>{djobComissionPercentage}%</span>
                <span>{djobComissionAsMoney}</span>
              </div>
              <div className={css.tableDataRow}>
                <span> </span>
                <span>{intl.formatMessage({ id: 'BusinessCheckoutPage.gstTaxes' })}</span>
                <span>{gstNumber}</span>
                <span>{gstTaxAsMoney}</span>
              </div>
              <div className={css.tableDataRow}>
                <span> </span>
                <span>{intl.formatMessage({ id: 'BusinessCheckoutPage.qstTaxes' })}</span>
                <span>{qstNumber}</span>
                <span>{qstTaxAsMoney}</span>
              </div>
              <div className={css.tableDataRow}>
                <span> </span>
                <span>{intl.formatMessage({ id: 'Invoice.TotalAmount' })}</span>
                <span></span>
                <span>{totalcommissionAsMoney}</span>
              </div>
            </div>
          </div>
          {/* <div className={css.taxAmount}> */}
          {/* <div className={css.DataDiv}>
            <span className={css.Text}>
              {' '}
              <FormattedMessage id="BusinessCheckoutPage.gstTaxes" />
            </span>

            <span className={css.No}>{gstTaxAsMoney}</span>
          </div> */}

          {/* <div className={css.DataDiv}>
            <span className={css.Text}>
              <FormattedMessage id="BusinessCheckoutPage.qstTaxes" />
            </span>
            <span className={css.No}>{qstTaxAsMoney}</span>
          </div> */}

          {/* {refundAndOvertimeLabelArr.map((data, indx) => (
            <div className={css.DataDiv} key={indx}>
              <span className={css.Text}>{data.label}</span>
              <span className={css.No}>{data.amount}</span>
            </div>
          ))} */}

          {/* </div> */}
        </div>
        {/* <div className={css.hr}></div> */}

        {/* <div className={css.DataDivTotalAmount}>
          <span className={css.Text}>
            <FormattedMessage id="Invoice.TotalAmount" />
          </span>

          <span className={css.No}>{totalAmountAsMoney}</span>
        </div> */}
      </div>
    </div>
  );
}

export default Invoice;
